export const seo = {
  title: "SEO Positioning",
  headerTitle: "Your store SEO score",
  headerDescription:
    "Improve your products' ranking on Google by optimizing title, slug and description.",
  tabs: {
    approved: "Optimized ({{count}})",
    toImprove: "To improve ({{count}})",
  },
  empty: {
    noProductsTitle: "You don't have products yet",
    noProductsDescription:
      "Create products to start optimizing their SEO positioning.",
    noProductsCta: "Create product",
    approvedEmpty: "No optimized products yet",
    improveEmpty: "All your products are optimized",
  },
  acquire: {
    title: "Activate SEO Positioning",
    description:
      "Optimize your products to appear first in Google search results.",
    cta: "Get add-on",
  },
  ai: {
    automaticWithAi: "Automatic with AI",
    improveWithAi: "Improve with AI",
    improvingWithAi: "Improving with AI...",
    selectAll: "Select all",
    cancel: "Cancel",
    selectProductsError: "Select at least one product to improve",
    improvementFailed: "Could not complete the AI improvement",
    fieldButton: "AI",
    acquireTitle: "Activate Artificial Intelligence",
    acquireDescription:
      "Generate SEO metadata automatically and improve several products at once.",
    predicting: "Generating with AI...",
    improvementSuccess: "AI improvement completed",
    jobInProgress:
      "This product is being improved with AI. Wait until it finishes to edit it.",
  },
  detail: {
    back: "Back",
    save: "Save",
    saving: "Saving...",
    saveSuccess: "SEO metadata saved successfully",
    saveError: "Could not save SEO metadata",
    loadError: "Product not found",
    fields: {
      targetKeyphrase: "Target keyphrase",
      targetKeyphraseHint: "Main word or phrase that describes the product",
      seoTitle: "SEO title",
      seoTitleHint: "Ideal between 22 and 60 characters",
      slug: "Slug / friendly URL",
      slugHint: "Ideal between 25 and 50 characters",
      metaDescription: "Meta description",
      metaDescriptionHint: "Ideal between 100 and 150 characters",
    },
  },
  score: {
    label: "{{score}}/100",
  },
};
